import { z } from "zod";

export const patientSearchFormSchema = z.object({
  id: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  dob: z
    .string()
    .optional()
    .refine((date) => !date || /^(\d{2}\/\d{2}\/\d{4})$/.test(date), {
      message: "Date must be in format 'mm/dd/yyyy'",
    })
    .refine(
      (date: string | undefined) =>
        !date || !Number.isNaN(new Date(date).getTime()),
      {
        message: "Invalid date",
      },
    )
    .refine(
      (date: string | undefined) => !date || new Date(date) < new Date(),
      {
        message: "Date must be in the past",
      },
    ),
});

export const visitSearchFormSchema = z.object({
  id: z.string().min(1, "Required"),
});
